import './SortableTable.scss'
import React, { useReducer, useState } from 'react'
import PropTypes from 'prop-types'
import ReactTable from 'react-table'
import clsx from 'clsx'
import { withRouter } from 'react-router-dom'

import RestoreEventModal from 'components/Modals/RestoreEventModal'

// Pagination
import Pagination from 'components/Pagination'
import Loader from 'components/Loader'

import {
  initialStateConfig,
  draftsColumns,
  activeColumns
} from 'components/SortableTable/Columns'

import { useTranslation } from 'react-i18next'

const NothingHereIcon = () =>
  // prettier-ignore
  <i className="NothingHereIcon">
    <svg viewBox="0 0 256 256" width="256" height="256"><path d="M128 0a128 128 0 0 1 128 128 128 128 0 0 1-128 128A128 128 0 0 1 0 128 128 128 0 0 1 128 0z" fill="#eaeef3"/><path d="M202 232.45V66.12a6 6 0 0 0-6-6H60a6 6 0 0 0-6 6v166.33a128 128 0 0 0 148 0z" fill="#fff"/><g><path d="M59 61.12h138a4 4 0 0 1 4 4v46H55v-46a4 4 0 0 1 4-4z" fill="#fafafc"/></g><path d="M90 77.12h54a1 1 0 0 1 1 1 1 1 0 0 1-1 1H90a1 1 0 0 1-1-1 1 1 0 0 1 1-1zM90 85.12h30a1 1 0 0 1 1 1 1 1 0 0 1-1 1H90a1 1 0 0 1-1-1 1 1 0 0 1 1-1zM88 155.12a9 9 0 1 1 9-9 9 9 0 0 1-9 9zm0-16a7 7 0 1 0 7 7 7 7 0 0 0-7-7z" fill="#3c5a7b"/><circle cx="88" cy="146.13" r="3" fill="#62a9f6"/><path d="M106 137.12h54a1 1 0 0 1 1 1 1 1 0 0 1-1 1h-54a1 1 0 0 1-1-1 1 1 0 0 1 1-1zM106 145.12h68a1 1 0 0 1 1 1 1 1 0 0 1-1 1h-68a1 1 0 0 1-1-1 1 1 0 0 1 1-1zM106 153.12h28a1 1 0 0 1 1 1 1 1 0 0 1-1 1h-28a1 1 0 0 1-1-1 1 1 0 0 1 1-1zM144 153.12h22a1 1 0 0 1 1 1 1 1 0 0 1-1 1h-22a1 1 0 0 1-1-1 1 1 0 0 1 1-1z" fill="#3c5a7b"/><g fill="#8591b4"><path d="M88 193.12a9 9 0 1 1 9-9 9 9 0 0 1-9 9zm0-16a7 7 0 1 0 7 7 7 7 0 0 0-7-7zM106 175.12h54a1 1 0 0 1 1 1 1 1 0 0 1-1 1h-54a1 1 0 0 1-1-1 1 1 0 0 1 1-1zM106 183.12h68a1 1 0 0 1 1 1 1 1 0 0 1-1 1h-68a1 1 0 0 1-1-1 1 1 0 0 1 1-1zM106 191.12h28a1 1 0 0 1 1 1 1 1 0 0 1-1 1h-28a1 1 0 0 1-1-1 1 1 0 0 1 1-1zM144 191.12h22a1 1 0 0 1 1 1 1 1 0 0 1-1 1h-22a1 1 0 0 1-1-1 1 1 0 0 1 1-1z"/></g><g fill="#8591b4"><path d="M88 231.12a9 9 0 1 1 9-9 9 9 0 0 1-9 9zm0-16a7 7 0 1 0 7 7 7 7 0 0 0-7-7zM106 213.12h54a1 1 0 0 1 1 1 1 1 0 0 1-1 1h-54a1 1 0 0 1-1-1 1 1 0 0 1 1-1zM106 221.12h68a1 1 0 0 1 1 1 1 1 0 0 1-1 1h-68a1 1 0 0 1-1-1 1 1 0 0 1 1-1zM106 229.12h28a1 1 0 0 1 1 1 1 1 0 0 1-1 1h-28a1 1 0 0 1-1-1 1 1 0 0 1 1-1zM144 229.12h22a1 1 0 0 1 1 1 1 1 0 0 1-1 1h-22a1 1 0 0 1-1-1 1 1 0 0 1 1-1z"/></g><path d="M75.71 76.76a1 1 0 0 0-1.42 0l-5.65 5.66a1 1 0 0 0 0 1.41l5.65 5.66a1 1 0 0 0 1.42 0l5.65-5.66a1 1 0 0 0 0-1.41z" fill="#d6dbe6"/><path d="M75 90.78a2 2 0 0 1-1.41-.58l-5.66-5.66a2 2 0 0 1 0-2.83l5.66-5.66a2 2 0 0 1 2.82 0l5.66 5.66a2 2 0 0 1 0 2.83l-5.66 5.66a2 2 0 0 1-1.41.58zm0-13.31l-5.66 5.65L75 88.78l5.66-5.66zm.71-.71l-.71.71z" fill="#3c5a7b"/><path d="M196 61.12H60a5 5 0 0 0-5 5v167a128 128 0 0 0 146 0v-167a5 5 0 0 0-5-5z" fill="none"/><path d="M55 66.12a5 5 0 0 1 5-5h136a5 5 0 0 1 5 5v167c.67-.47 1.34-.94 2-1.42V66.12a7 7 0 0 0-7-7H60a7 7 0 0 0-7 7v165.61c.66.48 1.33 1 2 1.42z" fill="#8591b4"/><path d="M180 81.37a4 4 0 0 0-5.65 0l-18.17 18.17-8.18-8.17a4 4 0 0 0-5.65 0l-19.75 19.75H201v-8.76z" fill="#fff"/><path d="M180.72 80.66a5 5 0 0 0-7.07 0l-17.47 17.46-7.46-7.46a5 5 0 0 0-7.07 0l-20.47 20.46H124l19-19.05a3 3 0 0 1 2.12-.87 3 3 0 0 1 2.12.87l7.47 7.47 1.41 1.41 1.42-1.41L175 82.07a3 3 0 0 1 2.12-.87 3 3 0 0 1 2.12.87l21.7 21.7v-2.83z" fill="#3c5a7b"/><path fill="#3c5a7b" d="M145.91 111.23l-2.82-.01 16.86-16.86 1.03 1.8-15.07 15.07z"/><path fill="#8591b4" d="M169.18 111.13H55v2h146v-2h-31.82z"/></svg>
  </i>

const EmptyState = ({ type }) => {
  const eventType = {
    drafts: 'drafts',
    active: 'active events',
    archived: 'archived events'
  }
  const { t } = useTranslation()

  return (
    <div className="TableEmptyState">
      <NothingHereIcon />
      <p className="NothingHereText">
        {t('noEventsText', { type: t(eventType[type]) })}
      </p>
    </div>
  )
}

const SortableTable = ({
  className,
  pagination,
  title,
  data,
  history,
  fetchEvents,
  removeEvent
}) => {
  const [state, setState] = useReducer(
    (prevState, nextState) => ({ ...prevState, ...nextState }),
    initialStateConfig
  )

  const { t } = useTranslation()

  const initialColumns =
    title === 'drafts'
      ? draftsColumns({ removeEvent })
      : activeColumns({ removeEvent })

  const columns = initialColumns.map(column => ({
    ...column,
    Header: t(column.Header)
  }))

  const generateLink = (id, state) => {
    const type = () => {
      switch (state) {
        case 'ACTIVE':
        case 'FULL':
          return 'result'
        default:
          return 'edit'
      }
    }
    return `/event/${id}/${type()}`
  }

  const handleRouteLink = rowInfo => {
    const { event, state } = rowInfo.original
    history.push(generateLink(event, state))
  }

  const handlePerPageChange = ({ target }) => {
    const { table } = state
    table.pageSize = target.value
    table.page = 0
    setState({ table })
  }

  const handlePageChange = ({ target }) => {
    const { table } = state
    table.page = parseInt(target.getAttribute('data-index'))
    setState({ table })
  }

  const { table, loading } = state
  const { pageSize, page } = table
  const tablePageSize = parseInt(pageSize === 'ALL' ? data.length : pageSize)

  const [restoringEvent, setRestoringEvent] = useState(null)

  return (
    <div
      className={clsx('SortableTable', className, {
        'is-empty': data.length === 0
      })}>
      <ReactTable
        getTrProps={(_, rowInfo) => {
          const { deleted_at } = rowInfo.original

          return {
            className: deleted_at ? 'is-deleted' : null,
            onClick: (e, handleOriginal) => {
              if (deleted_at) {
                setRestoringEvent(rowInfo.original)
              } else {
                handleRouteLink(rowInfo)
              }

              if (handleOriginal) {
                handleOriginal()
              }
            }
          }
        }}
        columns={columns}
        data={data}
        page={page}
        pageSize={tablePageSize}
        showPagination={false}
        filterable={false}
        resizable={false}
        minRows={0}
        PadRowComponent={() => false}
        loading={loading}
        LoadingComponent={() => loading && <Loader />}
        NoDataComponent={() => <EmptyState type={title} />}
      />
      {pagination && data.length > 0 && (
        <Pagination
          data={data}
          perPage={pageSize}
          page={page}
          handlePageChange={handlePageChange}
          handlePerPageChange={handlePerPageChange}
        />
      )}
      {restoringEvent ? (
        <RestoreEventModal
          handleClose={() => setRestoringEvent(null)}
          event={restoringEvent}
          onRestore={() => {
            fetchEvents()
            setRestoringEvent(null)
          }}
        />
      ) : null}
    </div>
  )
}

export default withRouter(SortableTable)

SortableTable.propTypes = {
  pagination: PropTypes.bool,
  data: PropTypes.arrayOf(PropTypes.object).isRequired
}
